"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_STATES = exports.TOKENS = exports.SIZE_OPTIONS = void 0;
var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var TOKENS = {
  heightButton: "heightButton",
  fontSizeButton: "fontSizeButton",
  paddingButton: "paddingButton",
  paddingButtonWithIcons: "paddingButtonWithIcons",
  paddingButtonWithLeftIcon: "paddingButtonWithLeftIcon",
  paddingButtonWithRightIcon: "paddingButtonWithRightIcon",
  spinnerWidth: "spinnerWidth",
  spinnerHeight: "spinnerHeight",
  marginRightIcon: "marginRightIcon"
};
exports.TOKENS = TOKENS;
var BUTTON_STATES = {
  DEFAULT: "default",
  HOVER: "hover",
  ACTIVE: "active",
  FOCUS: "focus"
};
exports.BUTTON_STATES = BUTTON_STATES;